import { Directive, inject, Input, OnInit, Optional } from '@angular/core';

import { PageContainerDirective } from "../page-container/page-container.directive";

@Directive({
  selector: '[wmParam]',
  standalone: true
})
export class PartialParamDirective implements OnInit {
  @Input() name: string;
  @Input() value: any;
  private partialParamsProvider: PageContainerDirective
  constructor() {
    this.partialParamsProvider = inject(PageContainerDirective);
  }

  ngOnInit() {
    (this.partialParamsProvider as any).widget._partialParams[this.name] = this.value;
    this.partialParamsProvider.loadPartialParamProperties();
  }
}

